import { render } from "./ReferenzenPage.vue?vue&type=template&id=2f78681e"
import script from "./ReferenzenPage.vue?vue&type=script&lang=js"
export * from "./ReferenzenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__